import React, { Component } from 'react';

interface Props {
	children: React.ReactNode;
	styles: {
		buttonsHeader: string;
		buttonsHeaderLeft: string;
		buttonsHeaderRight: string;
	};
}

export default class SegmentedSelectButtonsHeader extends Component<Props> {
	static defaultProps = {
		styles: {},
	};

	render() {
		const { children, styles } = this.props;
		const buttons = React.Children.toArray(children);

		return (
			<div className={styles.buttonsHeader}>
				<div className={styles.buttonsHeaderLeft}>{buttons[0]}</div>
				<div className={styles.buttonsHeaderRight}>{buttons[1]}</div>
			</div>
		);
	}
}
